import catheter from '@/sui/data/sheets/edit/catheter'
import micro from '@/sui/data/sheets/edit/micro'
import multi from '@/sui/data/sheets/edit/multi'
import patient from '@/sui/data/sheets/edit/patient'
import bact from '@/sui/data/sheets/edit/bact'
import pneu from '@/sui/data/sheets/edit/pneu'
import intub from '@/sui/data/sheets/edit/intub'
import tools from '@/sui/data/sheets/edit/tools'
import cfg from '@/sui/data/sheets/edit/cfg/reaInfADI'
import fields from '@/sui/data/sheets/edit/fields'
import notes from '@/sui/data/sheets/edit/notes/reaInfADI'

const titles = [
  {
    text: 'DONNÉES ADMINISTRATIVES DU PATIENT',
    type: 'title',
    start: 'uf'
  },

  {
    text: `DONNÉES RELATIVES À L'EXPOSITION AUX DISPOSITIFS INVASIFS`,
    type: 'title',
    start: fields.ecmo
  },

  {
    text: 'ECMO / INTUBATION / TRACHEO',
    type: 'subtitle',
    start: fields.ecmo
  },

  {
    text: 'SONDAGE URINAIRE',
    type: 'subtitle',
    start: fields.urinary
  },

  {
    text: 'DEVENIR DU PATIENT',
    type: 'title',
    start: fields.dead
  },

  {
    text: `DONNÉES RELATIVES À L'EXPOSITION AUX DISPOSITIFS INVASIFS (SUITE)`,
    start: fields.catheterArray,
    type: 'title'
  },
  {
    text: 'INFECTION ASSOCIÉE AUX SOINS (HORS INFECTION LIÉE À UN CATHÉTER CENTRAL)',
    type: 'title',
    start: fields.bactArray
  }
]

const patientFields = {
  v1: [
    patient.sheetNumber.v1,
    patient.ufs.reaInfADI,
    patient.unitType.v1.ro,
    patient.birthdate,
    patient.sex,
    patient.entrydate,
    patient.patientOrigin.v1,
    patient.trauma,
    patient.diagnosis,
    patient.immuno,
    patient.antibio,
    patient.igsII,
    patient.pimII.std,
    patient.otherSeverity,
    patient.otherSeverityScore,
    patient.portageBmrBhre,
    patient.bmrBhreMicroOrg.v1,
    intub.ecmo,
    intub.intubated.std,
    intub.intubStart.std,
    intub.reintubated.std,
    intub.intubEnd.std,
    cfg.urinary,
    cfg.urinaryStart,
    cfg.urinaryEnd,
    patient.dead,
    patient.deathDate,
    patient.exitDate
  ],

  v2: [
    patient.sheetNumber.v2,
    patient.ufs.reaInfADI,
    patient.unitType.v1.ro,
    patient.birthdate,
    patient.sex,
    patient.entrydate,
    patient.patientOrigin.v2,
    patient.trauma,
    patient.diagnosis,
    patient.immuno,
    patient.cancer,
    patient.antibio,
    patient.igsII,
    patient.pimII.std,
    patient.otherSeverity,
    patient.otherSeverityScore,
    patient.portageBmrBhre,
    patient.bmrBhreMicroOrg.v2,
    intub.ecmo,
    intub.intubated.std,
    intub.intubStart.std,
    intub.reintubated.std,
    intub.intubEnd.std,
    cfg.urinary,
    cfg.urinaryStart,
    cfg.urinaryEnd,
    patient.dead,
    patient.deathDate,
    patient.exitDate
  ],

  v3: [
    patient.sheetNumber.v2,
    patient.ufs.reaInfADI,
    patient.unitType.v1.ro,
    patient.birthdate,
    patient.sex,
    patient.entrydate,
    patient.patientOrigin.v3,
    patient.trauma,
    patient.diagnosis,
    patient.immuno,
    patient.cancer,
    patient.antibio,
    patient.igsII,
    patient.pimII.std,
    patient.otherSeverity,
    patient.otherSeverityScore,
    patient.portageBmrBhre,
    patient.bmrBhreMicroOrg.v2,
    intub.ecmo,
    intub.intubated.std,
    intub.intubStart.std,
    intub.reintubated.std,
    intub.intubEnd.std,
    cfg.urinary,
    cfg.urinaryStart,
    cfg.urinaryEnd,
    patient.dead,
    patient.deathDate,
    patient.exitDate,
    multi.covidStatus.exit
  ],

  v4: [
    patient.sheetNumber.v2,
    patient.ufs.reaInfADI,
    patient.unitType.v1.ro,
    patient.birthdate,
    patient.sex,
    patient.entrydate,
    patient.patientOrigin.v3,
    patient.trauma,
    patient.diagnosis,
    patient.immuno,
    patient.cancer,
    patient.antibio,
    patient.igsII,
    patient.pimII.std,
    patient.otherSeverity,
    patient.otherSeverityScore,
    patient.bmi,
    patient.portageBmrBhre,
    patient.bmrBhreMicroOrg.v2,
    intub.ecmo,
    intub.intubated.std,
    intub.intubStart.std,
    intub.reintubated.std,
    intub.intubEnd.std,
    cfg.urinary,
    cfg.urinaryStart,
    cfg.urinaryEnd,
    patient.dead,
    patient.deathDate,
    patient.exitDate,
    multi.covidStatus.exit
  ],

  v5: [
    patient.sheetNumber.v2,
    patient.ufs.reaInfADI,
    patient.unitType.v2.ro,
    patient.birthdate,
    patient.sex,
    patient.entrydate,
    patient.patientOrigin.v3,
    patient.trauma,
    patient.diagnosis,
    patient.immuno,
    patient.cancer,
    patient.antibio,
    patient.igsII,
    patient.pimII.std,
    patient.otherSeverity,
    patient.otherSeverityScore,
    patient.bmi,
    patient.portageBmrBhre,
    patient.bmrBhreMicroOrg.v2,
    intub.ecmo,
    intub.intubated.std,
    intub.intubStart.std,
    intub.reintubated.std,
    intub.intubEnd.std,
    cfg.urinary,
    cfg.urinaryStart,
    cfg.urinaryEnd,
    patient.dead,
    patient.deathDate,
    patient.exitDate,
    multi.covidStatus.exit
  ]
}

const catheterFields = {
  v1: [
    cfg.catheterType.v1,
    catheter.insertionDate,
    cfg.catheterInsertion.v1,
    catheter.removed,
    tools.select(catheter.removalDate, catheter.select.ktr),
    tools.select(catheter.labo.v1, catheter.select.ktr),
    cfg.isColIlcBlc,
    cfg.colIlcBlc,
    tools.select(micro.v1.noVirus, cfg.select.colIlcBlc)
  ],

  v2: [
    cfg.catheterType.v2,
    catheter.insertionDate,
    cfg.catheterInsertion.v2,
    catheter.removed,
    tools.select(catheter.removalDate, catheter.select.ktr),
    tools.select(catheter.labo.v2, catheter.select.ktr),
    cfg.isColIlcBlc,
    cfg.colIlcBlc,
    tools.select(bact.diagDate.v1, cfg.select.colIlcBlc),
    tools.select(multi.covidStatus.std, cfg.select.colIlcBlc),
    tools.select(bact.lipids.v2, cfg.select.colIlcBlc),
    tools.select(bact.divDiag.v1.adped, cfg.select.blc),
    tools.select(micro.v2.noVirus, cfg.select.colIlcBlc)
  ],

  v3: [
    cfg.catheterType.v2,
    catheter.insertionDate,
    cfg.catheterInsertion.v2,
    catheter.removed,
    tools.select(catheter.removalDate, catheter.select.ktr),
    tools.select(catheter.labo.v2, catheter.select.ktr),
    cfg.isColIlcBlc,
    cfg.colIlcBlc,
    tools.select(bact.diagDate.v1, cfg.select.colIlcBlc),
    tools.select(bact.previousManip, cfg.select.ktm.v1),
    tools.select(bact.previousManipType.v1, cfg.select.ktm7.v1),
    tools.select(bact.previousManipDate, cfg.select.ktm7.v1),
    tools.select(multi.covidStatus.std, cfg.select.colIlcBlc),
    tools.select(bact.lipids.v2, cfg.select.colIlcBlc),
    tools.select(bact.divDiag.v2, cfg.select.blc),
    tools.select(bact.clinicalSigns, cfg.select.dd5),
    tools.select(bact.bioSigns, cfg.select.dd5),
    tools.select(bact.adaptedAntibio, cfg.select.dd5),
    tools.select(bact.twoHemocs, cfg.select.dd5),
    tools.select(micro.v3.noVirus, cfg.select.colIlcBlc)
  ],

  v4: [
    cfg.catheterType.v2,
    catheter.insertionDate,
    cfg.catheterInsertion.v3,
    catheter.removed,
    tools.select(catheter.removalDate, catheter.select.ktr),
    tools.select(catheter.labo.v2, catheter.select.ktr),
    cfg.isColIlcBlc,
    cfg.colIlcBlc,
    tools.select(bact.diagDate.v1, cfg.select.colIlcBlc),
    tools.select(bact.bactOrigin.v2, cfg.select.blc),
    tools.select(bact.previousManip, cfg.select.ktm.v1),
    tools.select(bact.previousManipType.v1, cfg.select.ktm7.v1),
    tools.select(bact.previousManipDate, cfg.select.ktm7.v1),
    tools.select(multi.covidStatus.std, cfg.select.colIlcBlc),
    tools.select(bact.lipids.v2, cfg.select.colIlcBlcC1C2C4),
    tools.select(bact.divDiag.v2, cfg.select.blc),
    tools.select(bact.clinicalSigns, cfg.select.dd5),
    tools.select(bact.bioSigns, cfg.select.dd5),
    tools.select(bact.adaptedAntibio, cfg.select.dd5),
    tools.select(bact.twoHemocs, cfg.select.dd5),
    tools.select(micro.v3.noVirus, cfg.select.colIlcBlc)
  ],

  v5: [
    cfg.catheterType.v2,
    catheter.insertionDate,
    cfg.catheterInsertion.v3,
    catheter.removed,
    tools.select(catheter.removalDate, catheter.select.ktr),
    tools.select(catheter.labo.v2, catheter.select.ktr),
    cfg.isColIlcBlc,
    cfg.colIlcBlc,
    tools.select(bact.diagDate.v1, cfg.select.colIlcBlc),
    tools.select(bact.bactOrigin.v2, cfg.select.blc),
    tools.select(bact.previousManip, cfg.select.ktm.v1),
    tools.select(bact.previousManipType.v1, cfg.select.ktm7.v1),
    tools.select(bact.previousManipDate, cfg.select.ktm7.v1),
    tools.select(multi.covidStatus.std, cfg.select.colIlcBlc),
    tools.select(bact.lipids.v2, cfg.select.colIlcBlcC1C2C4),
    tools.select(bact.divDiag.v2, cfg.select.blc),
    tools.select(bact.clinicalSigns, cfg.select.dd5),
    tools.select(bact.bioSigns, cfg.select.dd5),
    tools.select(bact.adaptedAntibio, cfg.select.dd5),
    tools.select(bact.twoHemocs, cfg.select.dd5),
    tools.select(micro.v4.noVirus, cfg.select.colIlcBlc)
  ],

  v6: [
    cfg.catheterType.v2,
    catheter.insertionDate,
    cfg.catheterInsertion.v3,
    catheter.removed,
    tools.select(catheter.removalDate, catheter.select.ktr),
    tools.select(catheter.labo.v2, catheter.select.ktr),
    cfg.isColIlcBlc,
    cfg.colIlcBlc,
    tools.select(bact.diagDate.v2, cfg.select.colIlcBlc),
    tools.select(bact.bactOrigin.v2, cfg.select.blc),
    tools.select(bact.previousManip, cfg.select.ktm.v1),
    tools.select(bact.previousManipType.v2, cfg.select.ktm7.v1),
    tools.select(bact.previousManipDate, cfg.select.ktm7.v1),
    tools.select(multi.covidStatus.std, cfg.select.colIlcBlc),
    tools.select(bact.lipids.v2, cfg.select.colIlcBlcC1C2C4),
    tools.select(bact.divDiag.v2, cfg.select.blc),
    tools.select(bact.clinicalSigns, cfg.select.dd5),
    tools.select(bact.bioSigns, cfg.select.dd5),
    tools.select(bact.adaptedAntibio, cfg.select.dd5),
    tools.select(bact.twoHemocs, cfg.select.dd5),
    tools.select(micro.v5.noVirus, cfg.select.colIlcBlc)
  ],

  v7: [
    cfg.catheterType.v3,
    catheter.insertionDate,
    cfg.catheterInsertion.v3,
    catheter.removed,
    tools.select(catheter.removalDate, catheter.select.ktr),
    tools.select(catheter.labo.v2, catheter.select.ktr),
    cfg.isColIlcBlc,
    cfg.colIlcBlc,
    tools.select(bact.diagDate.v2, cfg.select.colIlcBlc),
    tools.select(bact.bactOrigin.v2, cfg.select.blc),
    tools.select(bact.previousManip, cfg.select.ktm.v2),
    tools.select(bact.previousManipType.v2, cfg.select.ktm7.v2),
    tools.select(bact.previousManipDate, cfg.select.ktm7.v2),
    tools.select(multi.covidStatus.std, cfg.select.colIlcBlc),
    tools.select(bact.lipids.v2, cfg.select.colIlcBlcC1C2C4),
    tools.select(bact.divDiag.v2, cfg.select.blc),
    tools.select(bact.clinicalSigns, cfg.select.dd5),
    tools.select(bact.bioSigns, cfg.select.dd5),
    tools.select(bact.adaptedAntibio, cfg.select.dd5),
    tools.select(bact.twoHemocs, cfg.select.dd5),
    tools.select(micro.v6.noVirus, cfg.select.colIlcBlc)
  ],

  v8: [
    cfg.catheterType.v3,
    catheter.insertionDate,
    cfg.catheterInsertion.v3,
    catheter.removed,
    tools.select(catheter.removalDate, catheter.select.ktr),
    tools.select(catheter.labo.v2, catheter.select.ktr),
    cfg.isColIlcBlc,
    cfg.colIlcBlc,
    tools.select(bact.diagDate.v2, cfg.select.colIlcBlc),
    tools.select(bact.bactOrigin.v2, cfg.select.blc),
    tools.select(bact.previousManip, cfg.select.ktm.v2),
    tools.select(bact.previousManipType.v2, cfg.select.ktm7.v2),
    tools.select(bact.previousManipDate, cfg.select.ktm7.v2),
    tools.select(multi.covidStatus.std, cfg.select.colIlcBlc),
    tools.select(bact.lipids.v3, cfg.select.colIlcBlcC1C2C4C8),
    tools.select(bact.divDiag.v2, cfg.select.blc),
    tools.select(bact.clinicalSigns, cfg.select.dd5),
    tools.select(bact.bioSigns, cfg.select.dd5),
    tools.select(bact.adaptedAntibio, cfg.select.dd5),
    tools.select(bact.twoHemocs, cfg.select.dd5),
    tools.select(micro.v6.noVirus, cfg.select.colIlcBlc)
  ]
}

const catheters = {}
for (let v in catheterFields) {
  const list = [catheter.present]
  const c = catheterFields[v]
  for (let i = 0; i !== c.length; ++i) {
    const l = c[i]
    list.push(tools.andSelect(l, catheter.select.kt))
  }
  catheters[v] = {
    field: fields.catheterArray,
    type: 'array',
    config: {
      title: 'CATHETER CENTRAL N°',
      fields: list
    }
  }
}

export default {
  '2026': {
    titles: titles,
    fields: [
      ...patientFields.v5,
      catheters.v8,
      {
        type: 'array',
        field: fields.bactArray,
        config: {
          title: 'BACTERIEMIE N°',
          fields: bact.all.v8.extra
        }
      },

      pneu.all.v6
    ],

    buildNotes: function (result, sheet, surveillance) {
      return notes.build2026(result, sheet, surveillance)
    }
  },

  '2025': {
    titles: titles,
    fields: [
      ...patientFields.v5,
      catheters.v7,
      {
        type: 'array',
        field: fields.bactArray,
        config: {
          title: 'BACTERIEMIE N°',
          fields: bact.all.v7.extra
        }
      },

      pneu.all.v5
    ],

    buildNotes: function (result, sheet, surveillance) {
      return notes.build2025(result, sheet, surveillance)
    }
  },

  '2024': {
    titles: titles,
    fields: [
      ...patientFields.v5,
      catheters.v6,
      {
        type: 'array',
        field: fields.bactArray,
        config: {
          title: 'BACTERIEMIE N°',
          fields: bact.all.v6.extra
        }
      },

      pneu.all.v4
    ],

    buildNotes: function (result, sheet, surveillance) {
      return notes.build2024(result, sheet, surveillance)
    }
  },

  '2023': {
    titles: titles,
    fields: [
      ...patientFields.v4,
      catheters.v5,
      {
        type: 'array',
        field: fields.bactArray,
        config: {
          title: 'BACTERIEMIE N°',
          fields: bact.all.v5.extra
        }
      },

      pneu.all.v3
    ],

    buildNotes: function (result, sheet, surveillance) {
      return notes.build2023(result, sheet, surveillance)
    }
  },

  '2022': {
    titles: titles,
    fields: [
      ...patientFields.v3,
      catheters.v4,
      {
        type: 'array',
        field: fields.bactArray,
        config: {
          title: 'BACTERIEMIE N°',
          fields: bact.all.v4.extra
        }
      },

      pneu.all.v2
    ],
    buildNotes: function (result, sheet, surveillance) {
      return notes.build2022(result, sheet, surveillance)
    }
  },

  '2021': {
    titles: titles,

    fields: [
      ...patientFields.v3,
      catheters.v3,
      {
        type: 'array',
        field: fields.bactArray,
        config: {
          title: 'BACTERIEMIE N°',
          fields: bact.all.v3.extra
        }
      },
      pneu.all.v2
    ],
    buildNotes: function (result, sheet, surveillance) {
      return notes.build2021(result, sheet, surveillance)
    }
  },

  '2020': {
    titles: titles,

    fields: [
      ...patientFields.v2,
      catheters.v2,
      {
        type: 'array',
        field: fields.bactArray,
        config: {
          title: 'BACTERIEMIE N°',
          fields: bact.all.v2.extra
        }
      },
      pneu.all.v2
    ],
    buildNotes: function (result, sheet, surveillance) {
      return notes.build2020(result, sheet, surveillance)
    }
  },

  '2019': {
    titles: titles,

    fields: [
      ...patientFields.v1,
      catheters.v1,
      {
        type: 'array',
        field: fields.bactArray,
        config: {
          title: 'BACTERIEMIE N°',
          fields: bact.all.v1.extra
        }
      },
      pneu.all.v1
    ],

    buildNotes: function (result, sheet, surveillance) {
      return notes.build2019(result, sheet, surveillance)
    }
  }
}
